module.exports = __webpack_public_path__ + "static/img/zanwu.25b511b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/riskReport/zanwu.png
// module id = 5qLG
// module chunks = 1